<template>
  <ResponsiveLayout
    sticky-actions
    :progress="progress"
    :show-lang-picker="false"
  >
    <template #header_start>
      <ButtonBack @click="emit('back')" />
    </template>
    <template #header_middle>
      <div class="kds-typography-title-medium">
        {{ $t('b2b_self_test_generic_assessment') }}
      </div>
    </template>
    <div class="kds-main-wrapper">
      <div class="kds-content-block">
        <h3
          class="kds-typography-title-xlarge"
          v-html="$t('b2b_self_test_pain_location_header')"
        />
        <div
          class="kds-typography-paragraph-large"
          v-html="$t('b2b_self_test_worst_pain_location_subtitle')"
        />
      </div>
      <div class="worst-pain-location self-test">
        <div class="person-wrap">
          <PainLocations
            :body-parts="[worstPainLocation]"
            :css-classes="['images', 'non-interactive', 'transparent']"
          />
        </div>
        <fieldset class="form-container">
          <div
            v-for="painLocation in painLocationListParts"
            :key="painLocation.key"
            :class="[
              'quiz-radio',
              { 'quiz-radio--checked': isPainLocationSelected(painLocation) },
            ]"
            @click="handlePainLocationChange(painLocation)"
          >
            <label class="quiz-radio__label kds-typography-title-medium">
              {{ $t(painLocation.value) }}
            </label>
            <div class="quiz-radio__layout">
              <CustomRadio
                :checked="isPainLocationSelected(painLocation)"
                :name="painLocation.key"
                :data-q-a-value="painLocation.key"
                :value="painLocation.key"
                data-q-a="pain-location"
              />
            </div>
          </div>
        </fieldset>
      </div>
    </div>

    <template #actions>
      <BaseButton
        :disabled="!isValid"
        :text="$t('generic_action_continue')"
        data-qa="submit"
        @click="handleNextEvent"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import CustomRadio from '@shared/components/CustomRadio.vue'
import PainLocations from '@shared/components/PainLocations.vue'
import BaseButton from '@shared/components/BaseButton.vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import ButtonBack from '@shared/components/ButtonBack.vue'
import { computed } from 'vue'
import useSelfTestStore from '@shared/modules/assessment/stores/useSelfTestStore.js'

const selfTestStore = useSelfTestStore()

defineProps({
  progress: {
    type: Number,
    default: null,
  },
  handleNextEvent: {
    type: Function,
    default: () => {},
  },
})

const emit = defineEmits(['back'])

const worstPainLocation = computed(() => selfTestStore.worstPainLocation)

const isValid = computed(() => worstPainLocation.value.length > 0)

const painLocationListParts = [
  {
    key: 'upper-back',
    value: 'b2b_self_test_pain_location_option_upper_back',
  },
  {
    key: 'lower-back',
    value: 'b2b_self_test_pain_location_option_lower_back',
  },
]

const handlePainLocationChange = (painLocation) => {
  selfTestStore.worstPainLocation = painLocation.key
}

const isPainLocationSelected = (painLocation) =>
  worstPainLocation.value === painLocation.key
</script>

<style lang="scss">
@use '@shared/modules/assessment/views/css/SelfTest.scss' as *;

.worst-pain-location {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin: 0 auto;

  .person-wrap {
    margin-right: 0;
    width: 40%;
    box-sizing: border-box;
  }
}
</style>
